import { combineReducers } from '@reduxjs/toolkit';
import { createFetchReducer } from 'store/setLocalStore';
import { PatientEducationListState } from './types';
import * as actions from './actions';

export interface PatientEducationState {
  list: PatientEducationListState;
}

export default combineReducers({
  list: createFetchReducer(actions.GET_LIST, true)
});
